import { ofType } from "redux-observable";
import { catchError, map, mergeMap, of } from "rxjs";
import {
  actionTypes,
  getAllRecoveryPointUsersFailureAction,
  getAllRecoveryPointUsersSuccessAction,
} from "./actions";
import { fetchGetAllAudits } from "./services";

const fetchGetAllAuditsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ALL_AUDITS),
    mergeMap((action: any) =>
      fetchGetAllAudits(action.payload).pipe(
        map((response: any) => getAllRecoveryPointUsersSuccessAction(response)),
        catchError((error: any) =>
          of(getAllRecoveryPointUsersFailureAction(error))
        )
      )
    )
  );

export default [fetchGetAllAuditsEpic];
